import { DashboardLayout } from "./DashboardLayout";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

interface ContentLayoutProps {
  children: React.ReactNode;
  title: string;
  backLink?: string;
  actionButton?: {
    label: string;
    onClick?: () => void;
    href?: string;
  };
}

export function ContentLayout({
  children,
  title,
  backLink = "/dashboard",
  actionButton,
}: ContentLayoutProps) {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 sm:gap-0">
          <div className="flex items-center gap-2">
            {backLink && (
              <Button asChild variant="ghost" size="icon" className="mr-2">
                <Link to={backLink}>
                  <ChevronLeft className="h-5 w-5" />
                </Link>
              </Button>
            )}
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">{title}</h1>
          </div>
          {actionButton && (
            <div className="w-full sm:w-auto">
              {actionButton.href ? (
                <Button asChild className="w-full sm:w-auto">
                  <Link to={actionButton.href}>{actionButton.label}</Link>
                </Button>
              ) : (
                <Button onClick={actionButton.onClick} className="w-full sm:w-auto">
                  {actionButton.label}
                </Button>
              )}
            </div>
          )}
        </div>
        <div className="bg-card rounded-lg border shadow">
          {children}
        </div>
      </div>
    </DashboardLayout>
  );
}
